export const api_host='https://api-ih.atentus.com'
export const api_auth='B7CE44ABF6CAGF59B80636E9C4F42B85'
export const key_auth='07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2'
export const tokenDuoc='siitoken'
export const token="123456"
export const especial=67724

